import { createSlice } from "@reduxjs/toolkit";

export interface InactivityState {
  open: boolean;
}

export const inactivityInitialState: InactivityState = {
  open: false,
};

export const InactivitySlice = createSlice({
  name: "inactivity",
  initialState: inactivityInitialState,
  reducers: {
    showAlert: (state) => ({
      ...state,
      open: true,
    }),

    hideAlert: (state) => ({
      ...state,
      open: false,
    }),
  },
});

export const InactivityActions = InactivitySlice.actions;
export const InactivityReducer = InactivitySlice.reducer;
